import cx from 'classnames';
import PropTypes from 'prop-types';
import { Node, Transforms } from 'slate';

import {
  getParentNode,
  getGrandParentPath,
  QUOTE_TEXT_DEFINITIONS,
  QUOTE_SOURCE_DEFINITIONS,
} from '@xing-com/content-editor-plugin-helpers';

import { Quote } from './Quote';
import styles from './Quote.css';
import { withQuote } from './utils';

const QuotePlugin = ({
  className,
  QUOTE_TAG,
  SOURCE_TAG,
  ...attributes
} = {}) => ({
  with: withQuote,
  renderElement: Quote({
    className: cx(styles.quote, className),
    QUOTE_TAG,
    SOURCE_TAG,
    ...attributes,
  }),
  onKeyDown: (event, editor) => {
    if (event.key === 'Backspace') {
      const parentNode = getParentNode(editor);
      const grandParentPath = getGrandParentPath(editor);
      const { selection } = editor;

      if (
        selection.anchor.offset === 0 &&
        parentNode.type === QUOTE_TEXT_DEFINITIONS.type
      ) {
        event.preventDefault();
        Transforms.removeNodes(editor, { at: grandParentPath });
      }
    }
    if (event.key === 'Enter') {
      const parentNode = getParentNode(editor);
      const grandParentPath = getGrandParentPath(editor);
      if (
        parentNode.type === QUOTE_SOURCE_DEFINITIONS.type &&
        Node.string(parentNode) === ''
      ) {
        Transforms.select(editor, {
          anchor: { path: [grandParentPath[0] + 1, 0], offset: 0 },
          focus: { path: [grandParentPath[0] + 1, 0], offset: 0 },
        });
      }
    }
  },
});

QuotePlugin.propTypes = {
  className: PropTypes.string,
  QUOTE_TAG: PropTypes.node,
  SOURCE_TAG: PropTypes.node,
};

export { QuotePlugin };
